/* ============
 * Dashboard
 * ============
 *
 * This is the dashboard page.
 */

import { mapMutations, mapGetters } from 'vuex';
import Forms from '../../utils/forms/forms';
import modulesService from '../../services/modules';
import organizationSettingsService from '../../services/organizationSettings';

export default {
  data() {
    return {
      form: new Forms({}),
      loading: false,
    };
  },

  props: {
    module: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      settings: 'organizationSettings',
    }),
  },

  mounted() {
    this.loading = true;
    const fields = {};
    for (let i = 0; i < this.module.fields.length; i++) {
      const newField = {
        type: this.module.fields[i].type || 'text',
        value: '',
      };
      fields[this.module.fields[i].name] = newField;
    }

    this.form = new Forms(fields);
    organizationSettingsService
      .show()
      .then(() => {
        this.loading = false;
      })
      .catch(() => {
        this.loading = false;
      });
  },

  watch: {},

  methods: {
    ...mapMutations({
      toggle: 'TOGGLE_MODAL',
      unsetModalContent: 'UNSET_MODAL_CONTENT',
    }),

    authorize() {
      if (!this.settings.hasVismaToken) {
        window.location.href = `${
        process.env.API_LOCATION
      }/visma/authenticate?token=${localStorage.getItem('id_token')}`;
      } else {
        this.subscribe();
      }
    },

    /**
     * Fetch the component's required resources.
     */
    getResources() {},

    subscribe() {
      this.form.loading = true;
      const obj = Object.assign(
        { module_id: this.module.id },
        this.form.data()
      );
      modulesService
        .subscribe(this.module.id, obj)
        .then(() => {
          modulesService.items().then(() => {
            this.closeModal();
          });
        })
        .catch((error) => {
          const message = error.data ? error.data.message : 'Field Required';
          this.$message({
            showClose: true,
            message,
            customClass: 'error',
          });
          this.form.recordErrors(error);
          this.form.loading = false;
        });
    },
    /*
     * Closes the modal
     */
    closeModal() {
      this.toggle(false);
      this.unsetModalContent();
    },
  },
  components: {
    VForm: require('./../../components/form/form.vue'),
    VMessage: require('./../../components/form/message/message.vue'),
  },
};



// WEBPACK FOOTER //
// ./src/app/components/accountingSetupVisma/accountingSetupVisma.js